/* Small accessibility additions; original resource scripts and media remain intact. */
(() => {
  const initialize = () => {
    document.querySelectorAll('.edu-resource-content').forEach((root) => {
      if (root.dataset.legacyReady) return;
      root.dataset.legacyReady = 'true';
      const label = (selector, text) => {
        const element = root.querySelector(selector);
        if (element) element.setAttribute('aria-label', text);
      };
      label('#prev', 'Canción anterior');
      label('#next', 'Canción siguiente');
      label('#btn-prev', 'Sonido anterior');
      label('#btn-next', 'Sonido siguiente');
      label('#btn-shuffle', 'Mezclar sonidos');
      label('#seek-bar', 'Avance del audio');
      label('#searchInput', 'Buscar palabras en inglés');
      label('#voiceSelect', 'Variante de pronunciación');
      label('#categorySelect', 'Categoría de palabras');
      const player = root.querySelector('#audio-element, #audio-engine');
      const play = root.querySelector('#play, #btn-play');
      const updatePlay = () => {
        if (player && play) play.setAttribute('aria-label', player.paused ? 'Reproducir audio' : 'Pausar audio');
      };
      if (player) {
        player.addEventListener('play', updatePlay);
        player.addEventListener('pause', updatePlay);
        player.addEventListener('ended', updatePlay);
        updatePlay();
      }
      const seek = root.querySelector('#progress-bar');
      if (seek && player) {
        seek.tabIndex = 0;
        seek.setAttribute('role', 'slider');
        seek.setAttribute('aria-label', 'Avance de la canción');
        seek.setAttribute('aria-valuemin', '0');
        seek.setAttribute('aria-valuemax', '100');
        const updateSeek = () => seek.setAttribute('aria-valuenow', String(Number.isFinite(player.duration) && player.duration > 0 ? Math.round(player.currentTime / player.duration * 100) : 0));
        updateSeek();
        player.addEventListener('timeupdate', updateSeek);
        seek.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (!Number.isFinite(player.duration)) return;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? player.duration : player.currentTime + (event.key === 'ArrowRight' ? 5 : -5);
          player.currentTime = Math.max(0, Math.min(player.duration, next));
        });
      }
      root.addEventListener('keydown', (event) => {
        const target = event.target.closest('.track, #track-list li, .verb-val');
        if (target && root.contains(target) && ['Enter', ' '].includes(event.key)) {
          event.preventDefault();
          target.click();
        }
      });
      root.addEventListener('click', (event) => {
        const repeat = event.target.closest('.repeat-button');
        const audio = root.querySelector('#actividadAudio');
        if (repeat && audio && audio.querySelector('source[src]')) {
          audio.currentTime = 0;
          audio.play().catch(() => { audio.focus(); });
        }
        const shuffle = root.querySelector('#btn-shuffle');
        if (shuffle) shuffle.setAttribute('aria-pressed', String(shuffle.classList.contains('active')));
        root.querySelectorAll('.level-btn').forEach((button) => {
          const level = button.classList.contains('beginner-btn') ? 'beginner' : 'intermediate';
          button.setAttribute('aria-pressed', String(!root.querySelector('#' + level)?.classList.contains('hidden')));
        });
      });
      const enhance = () => {
        root.querySelectorAll('.track, #track-list li, .verb-val').forEach((element) => {
          element.tabIndex = 0;
          element.setAttribute('role', 'button');
        });
        root.querySelectorAll('.track img').forEach((img) => { img.alt = ''; });
        root.querySelectorAll('.duo-card .play-btn').forEach((button) => {
          button.setAttribute('aria-label', 'Escuchar ' + button.closest('.duo-card').querySelector('.word-text').textContent.trim());
        });
        root.querySelectorAll('.alphabet-card').forEach((card) => {
          const letter = card.querySelector('.big-letter').textContent.trim();
          const word = card.querySelector('.example-word').textContent.trim();
          const buttons = card.querySelectorAll('.audio-btn');
          if (buttons[0]) buttons[0].setAttribute('aria-label', 'Escuchar la letra ' + letter);
          if (buttons[1]) buttons[1].setAttribute('aria-label', 'Escuchar ' + word);
          const img = card.querySelector('.word-image');
          if (img) { img.alt = word; img.loading = 'lazy'; img.width = 95; img.height = 95; }
        });
        root.querySelectorAll('audio').forEach((audio) => {
          audio.preload = 'none';
          if (audio.dataset.resourceAudio) return;
          audio.dataset.resourceAudio = 'true';
          audio.addEventListener('play', () => {
            root.querySelectorAll('audio').forEach((other) => { if (other !== audio) other.pause(); });
          });
        });
      };
      root.querySelectorAll('.level-btn').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.classList.contains('beginner-btn')));
      });
      const shuffle = root.querySelector('#btn-shuffle');
      if (shuffle) shuffle.setAttribute('aria-pressed', 'false');
      enhance();
      // Search, filtering, and playlists generate new buttons and cards.
      new MutationObserver(enhance).observe(root, {childList: true, subtree: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
})();
